module.exports = __webpack_public_path__ + "media/images/icons/facebook-efeb2b86bb8d433098b5aa96f34d12916e915716915d698a6dc4ee3ab2a4b9b1.png";